/**
 * Typed failure modes of deleting a workspace (spec 003 FR-007/008/009/010).
 *
 * The dialog switches on `kind`, never on message text, so the three outcomes
 * a person must be able to tell apart — "wait and retry", "already gone", and
 * "nothing happened, try again" — stay distinguishable however the copy is
 * reworded.
 */

export type WorkspaceDeleteErrorKind =
  'active-execution' | 'not-found' | 'unavailable';

export class WorkspaceDeleteError extends Error {
  readonly kind: WorkspaceDeleteErrorKind;

  constructor(kind: WorkspaceDeleteErrorKind, message: string) {
    super(message);
    this.name = 'WorkspaceDeleteError';
    this.kind = kind;
  }
}
